import { React } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from '../../components/Commons/Navbar'
import CampaignHeader from './CampaignHeader'
import About from '../Home/About'
import Faq from '../Home/Faq'
import Footer from '../../components/Layouts/Footer'
import { useCampaign } from '../Home/useCampaign'

const CampaignHome = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const campaignToken = searchParams.get('token')

  const { campaignData, isValid } = useCampaign(campaignToken)

  return (
    <div className="home">
      <Navbar />
      {location.state?.error && (
        <div className="container mt-3">
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>
              <i className="fa fa-exclamation-circle"></i> Lo sentimos
            </strong>
            <br />
            {location.state.error}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => window.history.replaceState({}, document.title)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      )}
      {location.state?.message && (
        <div className="container mt-3">
          <div className="alert alert-info alert-dismissible fade show" role="alert">
            <strong>
              <i className="fa fa-info-circle"></i> Información
            </strong>
            <br />
            {location.state.message}
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => window.history.replaceState({}, document.title)}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      )}
      <CampaignHeader campaignToken={campaignToken} campaignData={campaignData} isValid={isValid} />
      <About />
      <Faq />
      <Footer />
    </div>
  )
}

export default CampaignHome
